$(document).ready(function () {
    function updateVariantId() {
        $('.mrk-active-variants .mrk-bundles__bar-variant__content').each(function () {
            var variantId = null;
            var selectedOptions = [];
            var _this = $(this);
            var options = $(this).find('select').val();
            $(this).find('select').each(function () {
                selectedOptions.push($(this).val());
            });
            $(this).find('.mrk-option-item:checked').each(function () {
                selectedOptions.push($(this).val());
            });
            // Fetch variants from the JSON script tag within the quantity-breaks element
            var variants = JSON.parse($('mrk-bundle').find('script[type="application/json"]').html());
            variants.forEach(function (variant) {
                var options = variant.options;
                if (JSON.stringify(options) === JSON.stringify(selectedOptions)) {
                    variantId = variant.id;
                    // var image_src = variant.featured_media.preview_image?.src.split('files/')[1].split('?')[0];
                    if($(_this).find(`[mrk-id="${window.selected_select}"]`).length){
                        $(`[mrk-thumbnail="${variant.featured_media.id}"]`).click();
                        if (window.matchMedia('(max-width: 767px)').matches) {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                        var swatch_Wrapper = $(_this).find('.ah-swatch-label-wrapper');
                        console.log(swatch_Wrapper, variant, $(_this));
                        $(swatch_Wrapper).find('img').attr('src', `${variant.featured_image.src}&width=200`);
                        $(swatch_Wrapper).find('.color-name').html(variant.option2);
                    }
                    if(variant.available){
                        $(this).find('.mrk-error').html('');
                    }else{
                        $(this).find('.mrk-error').html(`${variant.title} is unavailable!`);
                    }
                }
            });
            if(variantId == null){
                $(this).parents('.mrk-bundles__bar-variant').find('.mrk-error').html(`${selectedOptions.join(', ')} is unavailable!`);
                
            }else{
                $(this).parents('.mrk-bundles__bar-variant').find('.mrk-error').html('');
            }
            $(this).attr('data-selected-id', variantId);

        });
    }
    function handleQuantityUpdate(){
        $('.mrk-active-variants').hide().removeClass('mrk-active-variants');
        $('.mrk-active-free-gifts').removeClass('mrk-active-free-gifts');
        var title = $('[name="quantity"]:checked').attr('rope');
        $(`.ah-variant-wrapper[title="${title}"]`).show().addClass('mrk-active-variants');
        $(`.ah-free-gift-wrapper[title="${title}"]`).addClass('mrk-active-free-gifts');
    }
    function createHiddenSubscription(index){
      var variantId = $('.mrk-addon-id:checked').val();
      var quantity = 1;
      var subscription = $('.mrk-subscription-coaching').val();
      if (variantId) {
          var hiddenInputId = $('<input>').attr({
              type: 'hidden',
              name: `items[${index}][id]`,
              value: variantId
          });
          var hiddenSubscription = '';
          if(subscription != ''){
              hiddenSubscription = $('<input>').attr({
                  type: 'hidden',
                  name: `items[${index}][selling_plan]`,
                  value: subscription
              });
          }
          var hiddenInputQuantity = $('<input>').attr({
              type: 'hidden',
              name: `items[${index}][quantity]`,
              value: quantity
          });
          
          $('.mrk-hidden-inputs').append(hiddenInputId,hiddenInputQuantity,hiddenSubscription);
      }
    }
    function createHiddenInputs() {
        const main_container = $('.product-details');
        $('.mrk-hidden-inputs').html('');
        var variants = [];
        if($('.mrk-product-page-bundle').length){
          $('.custom-hidden-input').prop('disabled', true);
        }
        var index = 1;
        $('.mrk-active-variants .quantity-break__selector-item').each(function () {
            var variantId = $(this).attr('data-selected-id');
            if (variantId) {
                variants.push({id: variantId, quantity: 1}); 
            }
        });
        
        $('[name="upsell-item"]:checked, [name="upsell_item"]:checked, .mrk-active-free-gifts .mrk-fixed-item').each(function(){
          var id = $(this).val(),
          quantity = Number($(this).attr('quantity')) || 1,
          parent_id = window.product_id,
          subscription_id = $(this).attr('subscription');
          if(subscription_id != ''){
            variants.push({id: id, quantity: quantity, selling_plan: subscription_id, parent: parent_id});
          }else{
            variants.push({id: id, quantity: quantity, parent: parent_id});
          }
        });
        $.each(variants, function(index, variant) {
          index = index + 1;
          var hiddenInputproperties = undefined;
          if (variant.id) {
            if(index == -1){
              // Create hidden input for variant id
              var hiddenInputId = $('<input>').attr({
                type: 'hidden',
                name: `id`,
                value: variant.id
              });
          
              // Create hidden input for variant quantity
              var hiddenInputQuantity = $('<input>').attr({
                type: 'hidden',
                name: `quantity`,
                value: variant.quantity
              });
            }else{
              // Create hidden input for variant id
              var hiddenInputId = $('<input>').attr({
                type: 'hidden',
                name: `items[${index}][id]`,
                value: variant.id
              });
          
              // Create hidden input for variant quantity
              var hiddenInputQuantity = $('<input>').attr({
                type: 'hidden',
                name: `items[${index}][quantity]`,
                value: variant.quantity
              });
              if(variant.parent){
                hiddenInputproperties = $('<input>').attr({
                type: 'hidden',
                name: `items[${index}][properties[_parent_id]]`,
                value: variant.parent
              });
              }
            }
            
        
            $('.mrk-hidden-inputs').append(hiddenInputId, hiddenInputQuantity, hiddenInputproperties);
        
            // If there's a selling plan, add that too
            if (variant.selling_plan) {
              var hiddenInputSellingPlan = $('<input>').attr({
                type: 'hidden',
                name: `items[${index}][selling_plan]`,
                value: variant.selling_plan
              });
              $('.mrk-hidden-inputs').append(hiddenInputSellingPlan);
            }
          }
        });
      
    }

    // Event listener for change on any select
    $('.mrk-bundles-option, .mrk-option-item').on('change', function () {
        window.selected_select = $(this).parents('.m-product-option').attr('mrk-id') || $(this).attr('mrk-id');
        updateVariantId();
        createHiddenInputs();
    });
    $('[name="quantity"]').on('change', function () {
        var rope = $(this).attr('rope');
        $(`[mrk-thumbnail] [alt="${rope}"]`).parents('[mrk-thumbnail]').click();
    });
    $('[name="quantity"],[name="selling-plan"],.mrk-addon-id').on('change', function () {
        updateVariantId();
        createHiddenInputs();
        $(this).parents('.mrk-bundles__bar')[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
    });
    $('[name="quantity"]').on('change', function () {
        handleQuantityUpdate();
        updateVariantId();
        createHiddenInputs()
    });
    // Initial update on page load
    handleQuantityUpdate();
    updateVariantId();
    createHiddenInputs(); 
    // setTimeout(function(){
    //   document.querySelectorAll('.m-product-media--slider__images .swiper-container').forEach((slider) => {
    //     slider.swiper.slideTo(1);
    //   })
    // },1000);
});
